import { User } from '../types/User';
import { apiGet, apiPostFormData, apiPut } from './apiClient';

export interface UpdateUserRequest {
  id: string;
  email: string;
  username: string;
}

export function getUserById(id: string): Promise<User> {
  return apiGet<User>(`/api/User/${id}`);
}

export function getAllUsers(): Promise<User[]> {
  return apiGet<User[]>('/api/User/all');
}

export function updateUser(body: UpdateUserRequest): Promise<void> {
  return apiPut(`/api/User/${body.id}`, body);
}

export async function uploadAvatar(
  userId: string,
  file: File
): Promise<{ avatarUrl: string }> {
  const formData = new FormData();
  formData.append('File', file);
  formData.append('UserId', userId);

  return apiPostFormData<{ avatarUrl: string }>('/api/Image/Avatar', formData);
}
